import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = ({ message = [], className = ''}) => {
  const errorMessage = useMemo(() => {
    if (!message || !Array.isArray(message) || message.length === 0) {
      return '';
    }
    return message[0];
  }, [message]);

  const isHtml = useMemo(() => {
    if (!errorMessage || typeof errorMessage !== 'string') {
      return false;
    }
    return /<\/?[a-z][\s\S]*>/i.test(errorMessage);
  }, [errorMessage]);

  if (!errorMessage) return null;

  return (
    <small className={`text-danger ${className}`}>
      {isHtml ? (
        <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
      ) : (
        errorMessage
      )}
    </small>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ])),
  ]),
  className: PropTypes.string,
};

export default ErrorMessage;
